import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Sport, StoryState } from '@sorare/core/src/__generated__/globalTypes';
import { isType, withFragments } from '@sorare/core/src/lib/gql';

import type { useDisplayFixtureStory_story } from './__generated__/useDisplayFixtureStory.graphql';

export const useDisplayFixtureStory = withFragments(
  (story?: useDisplayFixtureStory_story | null) => {
    const { aasmState, readable: so5Fixture } = story || {};

    return (
      !!story &&
      isType(so5Fixture, 'So5Fixture') &&
      aasmState === StoryState.READY &&
      so5Fixture.sport !== Sport.BASEBALL
    );
  },
  {
    story: gql`
      fragment useDisplayFixtureStory_story on Story {
        id
        aasmState
        readable {
          ... on So5Fixture {
            slug
            sport
          }
        }
      }
    ` as TypedDocumentNode<useDisplayFixtureStory_story>,
  }
);
